import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { pure } from 'recompose'

function CounterBadge({ count, color, size, style, className }) {
  if (count < 1) {
    return null
  }
  const dimension = CounterBadge.DIMENSIONS[size]
  const counterClassName = classNames(
    className,
    [
      'flexbox flexbox-centered',
      'shade-100-important',
      'bold',
      'radius-round',
      'center-text',
    ],
    {
      'font-size-smallest': size !== 'large',
      'background-shade-20': color === 'default',
      'background-green': color === 'primary',
      'background-red': color === 'secondary',
    }
  )
  return (
    <div
      style={{ width: dimension, height: dimension, ...style }}
      className={counterClassName}
    >
      {count > 99 ? '99+' : count}
    </div>
  )
}

CounterBadge.propTypes = {
  style: PropTypes.any,
  count: PropTypes.number.isRequired,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']).isRequired,
  size: PropTypes.oneOf(['default', 'small', 'medium', 'large']).isRequired,
}

CounterBadge.defaultProps = {
  color: 'default',
  size: 'default',
}

CounterBadge.DIMENSIONS = {
  large: 24,
  default: 18,
  medium: 14,
  small: 12,
}

export default pure(CounterBadge)
